<template>
    <item-form
            :model="model"
            :isEditing="false"
            @save-item="addItem">
    </item-form>
</template>

<script>
    import api from '../../api/glastype';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                model: {
                },
            };
        },
        methods: {
            addItem (model) {
                api.addGlastype(model).then(() => {
                    this.$router.replace('/beheer/glastype');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/glastype/New.vue